(() => {
  const containers = document.querySelectorAll('[data-different-bottom-prices]');

  if (!containers.length) return;

  const formatWithDelimiters = (cents, precision = 2, thousands = ',', decimal = '.') => {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '0';

    const parts = (amount / 100).toFixed(precision).split('.');
    const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    return whole + (parts[1] ? `${decimal}${parts[1]}` : '');
  };

  const formatMoney = (cents, format) => {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholder);
    if (!match) return format;

    const formatters = {
      amount: () => formatWithDelimiters(cents),
      amount_no_decimals: () => formatWithDelimiters(cents, 0),
      amount_with_comma_separator: () => formatWithDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => formatWithDelimiters(cents, 0, '.', ','),
      amount_with_space_separator: () => formatWithDelimiters(cents, 2, ' ', ','),
      amount_no_decimals_with_space_separator: () => formatWithDelimiters(cents, 0, ' '),
      amount_with_apostrophe_separator: () => formatWithDelimiters(cents, 2, "'", '.')
    };
    const formatter = formatters[match[1]] || formatters.amount;
    return format.replace(placeholder, formatter());
  };

  const getResolvedVariant = (item) => {
    const variantsElement = item.querySelector(':scope > [id^="VariantsJson-"]');
    if (!variantsElement) return null;

    let variants;
    try {
      variants = JSON.parse(variantsElement.value || variantsElement.textContent);
    } catch (error) {
      return null;
    }

    const optionGroups = [...item.querySelectorAll('.variant-input-wrap')];
    if (!optionGroups.length) {
      const selectedId = item.querySelector('.product-single__variants')?.value;
      return variants.find((variant) => String(variant.id) === selectedId && variant.available) || null;
    }

    const selectedOptions = optionGroups.map((group) => group.querySelector('input:checked')?.value);
    if (selectedOptions.some((value) => value === undefined)) return null;

    return variants.find((variant) => {
      return variant.available && variant.options.every((option, index) => option === selectedOptions[index]);
    }) || null;
  };

  containers.forEach((container) => {
    const productInformation = container.closest('.product-information--inner');
    const form = productInformation?.querySelector('.product-single__form');
    if (!form) return;

    const priceElement = container.querySelector('[data-set-price]');
    const compareElement = container.querySelector('[data-set-compare-price]');
    const compareWrapper = compareElement?.closest('del');
    const saleBadge = container.querySelector('[data-set-sale-badge]');
    const moneyFormat = container.dataset.moneyFormat;

    const updateSaleDisplay = (price, compareAtPrice) => {
      const onSale = compareAtPrice > price;
      compareWrapper.hidden = !onSale;
      if (!onSale) {
        saleBadge.textContent = '';
        saleBadge.hidden = true;
        return;
      }

      compareElement.innerHTML = formatMoney(compareAtPrice, moneyFormat);
      const savings = compareAtPrice - price;

      if (container.dataset.saleBadgeType === 'save_amount') {
        saleBadge.innerHTML = container.dataset.saveTemplate.replace(
          '[saved_amount]',
          formatMoney(savings, moneyFormat)
        );
      } else if (container.dataset.saleBadgeType === 'save_percentage') {
        const percentage = `${Math.round((savings * 100) / compareAtPrice)}%`;
        saleBadge.innerHTML = container.dataset.saveTemplate.replace('[saved_amount]', percentage);
      } else {
        saleBadge.textContent = container.dataset.saleLabel;
      }

      saleBadge.hidden = !saleBadge.textContent.trim();
    };

    const showStartingPrice = () => {
      const parentPrice = Number(container.dataset.parentPrice);
      const parentCompareAtPrice = Number(container.dataset.parentCompareAtPrice);
      const formattedPrice = formatMoney(parentPrice, moneyFormat);
      priceElement.innerHTML = container.dataset.startingPriceTemplate.replace('[price]', formattedPrice);
      updateSaleDisplay(parentPrice, parentCompareAtPrice);
    };

    const updatePrice = () => {
      const childItems = [...form.querySelectorAll('.bundle-items--wrapper > .bundle-item')].slice(0, 2);
      if (childItems.length !== 2) {
        showStartingPrice();
        return;
      }

      const variants = childItems.map(getResolvedVariant);
      if (variants.some((variant) => !variant)) {
        showStartingPrice();
        return;
      }

      const price = variants.reduce((total, variant) => total + variant.price, 0);
      const compareAtPrice = variants.reduce((total, variant) => {
        return total + (variant.compare_at_price || variant.price);
      }, 0);

      priceElement.innerHTML = formatMoney(price, moneyFormat);
      updateSaleDisplay(price, compareAtPrice);
    };

    form.addEventListener('change', (event) => {
      if (!event.target.matches('.bundle-item .variant-input input')) return;
      window.setTimeout(updatePrice, 0);
    });

    if (window.jQuery) {
      window.jQuery(form)
        .find('.bundle-item')
        .on('variantChange.differentBottomPrices', updatePrice);
    }

    showStartingPrice();
    window.setTimeout(updatePrice, 1600);
  });
})();
